import React, { useEffect, useState } from "react"
import * as yup from "yup"

import { Modal, Col, Row, Form } from "react-bootstrap"

import API from "../../common/API"
import { v4 as uuidv4 } from "uuid"

import { useFormik } from "formik"
import { parsedUser } from "../../common/GetCurrentUser"
import moment from "moment"

import "./organization.css"
//Translation
import { useTranslation } from "react-i18next"

//Validation
const validationSchema = yup.object({
  name: yup.string().required(),
  identifier: yup.string().required(),
  country: yup.string().required(),
  email: yup.string().required(),
})
///Component

const AddEditOrganization = props => {
  const [state, setState] = useState({
    UI: {
      Validated: false,
      isLoading: false,
    },
  })

  const [user, setUser] = useState(null)

  const { t } = useTranslation("global")

  useEffect(() => {
    setUser(parsedUser())
  }, [])

  const handleSubmit = async (obj, event) => {
    console.log("values to submit", obj)
    let currentUser = parsedUser()
    debugger
    if (obj.id.length === 0) {
      obj.id = uuidv4()
      obj.created = moment().format("YYYY-MM-DD HH:mm:ss")

      obj.creatorId = user.id
    }
    setState({
      ...state,
      UI: {
        ...state.UI,
        isLoading: !state.UI.isLoading,
      },
    })
    let request = await API.postAction(
      "Organization/AddEdit?currentUserId=" + currentUser.ID,
      obj
    )
    setState({
      ...state,
      UI: {
        ...state.UI,
        isLoading: !state.UI.isLoading,
      },
    })
    console.log("response from adding", request)
    if (request.status === 200) {
      props.toggle(true)
    }
  }

  const formik = useFormik({
    initialValues: props.model
      ? JSON.parse(JSON.stringify(props.model))
      : {
          name: "",
          identifier: "",
          city: "",
          country: "",
          id: "",
          organizationTimeZone: "SA Western Standard Time",
        },
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: handleSubmit,
  })
  return (
    <Modal show={props.show} onHide={props.toggle} size="md">
      <Modal.Header closeButton>
        <Modal.Title>{t("organization")}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <Row>
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>
                {t("id")} / {t("rnc")}
              </Form.Label>
              <Form.Control
                type="text"
                name="identifier"
                value={formik.values.identifier ? formik.values.identifier : ""}
                onChange={formik.handleChange}
              />
              {formik.errors.identifier ? (
                <div className="invalid text-sm">
                  {formik.errors.identifier}
                </div>
              ) : null}
            </Col>
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>{t("name")}</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
              />
              {formik.errors.name ? (
                <div className="invalid text-sm">{formik.errors.name}</div>
              ) : null}
            </Col>
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>{t("type")}</Form.Label>
              <select
                className="form-control"
                id="organizationTypeID"
                name="organizationTypeID"
              >
                <option value="1">{t("product_and_service")}</option>
              </select>
              {formik.errors.organizationTypeID ? (
                <div className="invalid text-sm">
                  {formik.errors.organizationTypeID}
                </div>
              ) : null}
            </Col>
         
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>{t("email")}</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formik.values.email ? formik.values.email : ""}
                onChange={formik.handleChange}
              />
              {formik.errors.email ? (
                <div className="invalid text-sm">{formik.errors.email}</div>
              ) : null}
            </Col>
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>{t("phone")}</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={formik.values.phone ? formik.values.phone : ""}
                onChange={formik.handleChange}
              />
              {formik.errors.phone ? (
                <div className="invalid text-sm">{formik.errors.phone}</div>
              ) : null}
            </Col>
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>{t("phone")} 2</Form.Label>
              <Form.Control
                type="text"
                name="phone2"
                value={formik.values.phone2 ? formik.values.phone2 : ""}
                onChange={formik.handleChange}
              />
              {formik.errors.phone2 ? (
                <div className="invalid text-sm">{formik.errors.phone2}</div>
              ) : null}
            </Col>
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>{t("address")}</Form.Label>
              <Form.Control
                type="text"
                name="address"
                value={formik.values.address ? formik.values.address : ""}
                onChange={formik.handleChange}
              />
              {formik.errors.address ? (
                <div className="invalid text-sm">{formik.errors.address}</div>
              ) : null}
            </Col>
            <Col xs={12} md={6}>
              <Form.Label>{t("city")}</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={formik.values.city ? formik.values.city : ""}
                onChange={formik.handleChange}
              />
              {formik.errors.city ? (
                <div className="invalid text-sm">{formik.errors.city}</div>
              ) : null}
            </Col>
            <Col xs={12} md={6} className="mb-2">
              <Form.Label>{t("zip_code")}</Form.Label>
              <Form.Control
                type="text"
                name="zipCode"
                value={formik.values.zipCode ? formik.values.zipCode : ""}
                onChange={formik.handleChange}
              />
              {formik.errors.zipCode ? (
                <div className="invalid text-sm">{formik.errors.zipCode}</div>
              ) : null}
            </Col>
            <Col xs={12} className="mb-2">
              <Form.Label>{t("country")}</Form.Label>
              <select
                className="form-control"
                value={formik.values.country}
                onChange={e => {
                  formik.setFieldValue("country", e.target.value)
                }}
              >
                <option value="">-</option>
                <option value="DO">{t("country.do")}</option>
                {/* <option value="PR">{t("country.pr")}</option> */}
                <option value="US">{t("country.us")}</option>
              </select>
              {formik.errors.country ? (
                <div className="invalid text-sm">{formik.errors.country}</div>
              ) : null}
            </Col>
            <Col xs={12} style={{ height: "200px" }}>
              {/* <ImageEditorComponent resize /> */}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary btn-block"
            type="submit"
            disabled={state.UI && state.UI.isLoading}
          >
            {t("save")}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default AddEditOrganization
